export default class StepData {

    id; // Irgendein Schlüssel, z.B. Name der Komponente, die den jew. Step darstellt o.ä.
    data;

    constructor(id = "", data = {}, disabled = false) {
        this.id = id;
        this.data = data;
    }
}